module.exports = __webpack_public_path__ + "static/media/logoTransparent.89c4a70f.png";